import { useQuery, useQueryClient } from "@tanstack/react-query";

const shiftDataKey = 'shiftData';

const fetchShiftData = async () => {
    return {
        payperiod: null,
        employee: null,
    }
}

export const useShiftData = () => {
    const queryClient = useQueryClient();

    const { data: shiftData = [] } = useQuery({
        queryKey: [shiftDataKey],
        queryFn: fetchShiftData,
        staleTime: Infinity
    });

    const setShiftData = (key, value) => {
        queryClient.setQueryData([shiftDataKey], (oldData) => ({
            ...oldData,
            [key]: value,
        }));
    };

    return {
        shiftData,
        setShiftData,
    }
}